import React from "react";
import "./pop-up.css"; // Optional: for styling
import { formatPhone } from '../../Utils/validations';

const PopupMenu = ({ isVisible, onClose, PersonData, employeeInfo, gateCodes, onNavigateToScheduling }) => {
  if (!isVisible) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="popup-close" onClick={onClose}>
          &times;
        </button>
        <h2>{PersonData.firstName || PersonData.custFirstName} {PersonData.lastName || PersonData.custLastName}</h2>
        <p><strong>Contact:</strong> {formatPhone(PersonData.contactNumber || PersonData.custContactNo)}</p>
        {(PersonData.email || PersonData.custEmail) && (
          <p><strong>Email:</strong> {PersonData.email || PersonData.custEmail}</p>
        )}
        {PersonData.secondaryEmail && (
          <p><strong>Secondary Email:</strong> {PersonData.secondaryEmail}</p>
        )}
        <p><strong>Address:</strong> {PersonData.empAddress || PersonData.custAddress}, {PersonData.empCity || PersonData.custCity}, {PersonData.empState || PersonData.custState} {PersonData.empZipCode || PersonData.custZip}</p>

        {Array.isArray(gateCodes) && gateCodes.length > 0 && (
          <div>
            <p style={{ marginBottom: '4px' }}><strong>Gate Codes:</strong></p>
            <ul style={{ margin: '0 0 8px', paddingLeft: '20px' }}>
              {gateCodes.map((code) => (
                <li key={code.gateCodeId} style={{ marginBottom: '2px', textAlign: 'left' }}>
                  <strong>{code.gateCode}</strong>
                  {code.gateCodeType ? ` (${code.gateCodeType})` : ''}
                  {code.gateCodeNotes ? ` — ${code.gateCodeNotes}` : ''}
                </li>
              ))}
            </ul>
          </div>
        )}

        {employeeInfo && (
          <>
            {employeeInfo.employeeName && (
              <p><strong>Assigned Technician:</strong> {employeeInfo.employeeName}</p>
            )}
            <p>
              <strong>Last Service Date:</strong>{' '}
              {employeeInfo.lastServiceDate || 'Not yet serviced this customer'}
            </p>
          </>
        )}

        <button onClick={onClose} style={{
          marginTop: '15px',
          padding: '5px 10px',
          borderRadius: '5px',
          backgroundColor: '#003366',
          color: '#fff',
          border: 'none',
          cursor: 'pointer',
        }}>
          Close
        </button>
      </div>
    </div>
  );
};
export default PopupMenu;
